import { IUser } from "@chainlit/react-client";
import { createContext } from "react";

export interface IUserContextValue {
  user: IUser | null | undefined;
  logout: (() => Promise<void>) | ((reload?: boolean) => Promise<void>);
}

export const UserContext = createContext<IUserContextValue | null>(null);